<section class="p-6">
  <div class="flex flex-row gap-4">
    <span class="f-s-20 flex-1">{{contact.id > 0? 'Edit' : 'Add'}} Person</span>
    <button mat-raised-button type="button" color="primary" [disabled]="!contactsForm.valid || processing"
      (click)="saveContact()">Save</button>
    <button mat-raised-button type="button" color="warn" (click)="cancel()">Cancel</button>
  </div>
</section>
<mat-dialog-content>
  <div class="flex flex-col gap-2">
    <form [formGroup]="contactsForm" (ngSubmit)="saveContact()" class="p-t-16">

      <div class="flex flex-col gap-4 gap-1 md:gap-4">

        <mat-form-field>
          <input matInput placeholder="First Name" formControlName="firstName">
          <mat-error *ngIf="contactsForm.get('firstName').invalid">
            Please enter a first name
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Last Name" formControlName="lastName">
          <mat-error *ngIf="contactsForm.get('lastName').invalid">
            Please enter a last name
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Title" formControlName="title">
        </mat-form-field>
        <span class="f-s-16"><strong>Roles</strong></span>
        <div class="flex flex-col">
          <div class="flex flex-col md:flex-row gap-4">
            <mat-checkbox formControlName="isDirector">
              Training Program Director
            </mat-checkbox>
            <mat-checkbox formControlName="isResponsible">
              Responsible Party
            </mat-checkbox>
            <mat-checkbox formControlName="isBusinessAgent">
              Registered Agent
            </mat-checkbox>
          </div>
          <div class="flex flex-col md:flex-row gap-4">
            <mat-checkbox formControlName="isLeadEducator">
              Lead Educator
            </mat-checkbox>
            <mat-checkbox formControlName="isInstructor">
              Instructor
            </mat-checkbox>
          </div>
        </div>
        <mat-form-field *ngIf="displayPhoneAndEmail()">
          <input matInput placeholder="Email" formControlName="email">
          <mat-error *ngIf="validateEmail()">
            Please enter an email adress
          </mat-error>
          <mat-error *ngIf="contactsForm.get('email').hasError('email')">
            This doesn't look like a valid email address
          </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="displayPhoneAndEmail()">
          <input matInput placeholder="Phone" formControlName="phone" mask="(000) 000-0000 000000">
          <mat-error *ngIf="validatePhone()">
            Please provide a phone number
          </mat-error>
          <mat-error *ngIf="contactsForm.get('phone').hasError('pattern')">
            Phone should match this format: (999) 999-9999 9999
          </mat-error>
        </mat-form-field>

        <mat-checkbox *ngIf="contactsForm.get('isDirector').value"  formControlName="directorAttestation">
          <div class="flex flex-col gap-2">
            <span>
              I certify and understand the training program director is responsible for student enrollment, tracking student progress and
              determining whether a student has successfully completed the training program.
            </span>
          </div>
        </mat-checkbox>
        <mat-error *ngIf="validateDirectorAttestation()">
          You must affirm that the person is qualified.
        </mat-error>

        <mat-checkbox *ngIf="contactsForm.get('isLeadEducator').value" formControlName="leadAttestation">
          <div class="flex flex-col gap-2">
            <span>
              I certify that this training program lead educator has sufficient experience, knowledge, skills, and ability to competently
              train students in their assigned subject matter. I understand and have communicated to this lead educator that they must
              understand the objectives of the training program and communicate effectively with students. I understand that this
              lead educator must demonstrate skill in instruction and student supervision.
            </span>
          </div>
        </mat-checkbox>
        <mat-error *ngIf="validateLeadAttestation()">
          You must affirm that the person is qualified.
        </mat-error>

        <mat-checkbox *ngIf="contactsForm.get('isInstructor').value" formControlName="instructorAttestation">
          <div class="flex flex-col gap-2">
            <span>
              I certify that this training program instructor has sufficient experience, knowledge, skills and ability to competently train
              students in their assigned subject matter. I understand and have communicated to the instructor that they must understand the
              objectives of the training program and communicate effectively with students. I understand that the instructor must demonstrate
              skill in instruction and student supervision.
            </span>
          </div>
        </mat-checkbox>
        <mat-error *ngIf="validateInstructorAttestation()">
          You must affirm that the person is qualified.
        </mat-error>

      </div>
    </form>
  </div>
</mat-dialog-content>
